module.exports = __webpack_public_path__ + "static/media/schedule_now.fc2365a7.svg";